const selectSkin = ({ skin, setSkin }) => {
  return (
    <div style={{ paddingTop: 5 }}>
      <select
        value={skin}
        onChange={(event) => {
          localStorage.setItem("gc-skin", event.target.value);
          setSkin(event.target.value);
          window.location.reload();
        }}
        className="form-control form-select browser-default"
      >
        <option value="light">light</option>
        <option value="dark">dark</option>
      </select>
    </div>
  );
};

export default selectSkin;
